/**
 * useBlockedUsers Hook (Web)
 * Thin wrapper around shared useBlockedUsers
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import {
  type UseBlockedUsersResult,
  useBlockedUsers as useBlockedUsersShared,
} from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

export type { UseBlockedUsersResult };

export function useBlockedUsers(): UseBlockedUsersResult {
  const { isAuthenticated, authFetch } = useAuth();

  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );

  return useBlockedUsersShared({ httpClient, isAuthenticated });
}
